import React, { useMemo, useState } from "react";
import GlobalCard from "../../../../../../components/GlobalCardComponent";
import { Backdrop, Box, Checkbox, Divider, Grid, Typography } from "@mui/material";
import BlueMediumButton from "../../../../../../components/customButtons/BlueMediumButton";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useSelector } from "react-redux";
import ErrorPopupScreen from "../../../../../../components/customPopup/ErrorPopupScreen";
import BlueDisableButton from "../../../../../../components/customButtons/BlueDisableButton";
import { handleFetchRealTestOrderApi, handleRealTestVerifyPayment } from "../../../PurchaseTestApis";
import Loader from "../../../../../../../SAPPages/components/Loader/Loader";
import SussceeffulyMessageScreen from "../../../../../../components/customPopup/SussceeffulyMessageScreen";
import { useLocation } from "react-router-dom";

export default function OrderSummary() {
    const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID;
    const userId =localStorage.getItem('userId')
      const location = useLocation();
  const defaultSelectedTestData = useSelector(
    (state) => state.selectedTestDataList.defaultTestDataList
  );
  const defaultAddressData = useSelector(
      (state) => state.testAddressData?.defaultAddressData
    );
  const [checked, setChecked] = React.useState(false);
    const [paymentProceessLoading, setPaymentProcessLoading] = useState(false);

  const currency = defaultSelectedTestData[0]?.currency || null;

  // Calculate Total Amount
  const totalAmount = useMemo(() => {
    // Subtotal (price × quantity)
    const subTotal = defaultSelectedTestData?.reduce((acc, item) => {
      const amount = Number(item.base_price || 0);
      const qty = Number(item.quantity || 1);
      return acc + amount * qty;
    }, 0);

    // 18% GST
    const tax = subTotal * 0.18;

    return {
      subTotal: subTotal - tax,
      tax,
      total: subTotal,
    };
  }, [defaultSelectedTestData]);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const [showMessage, setShowMessga] = useState(null);
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [buttonTitle, setButtonTitle] = useState(null);
    const [openSuccesPopup, setOpenSuccesPopup] = useState(false);

  

  // error popup

  const handleOpenErrorPopup = () => {
    setOpenErrorPopup(true);
  };

  const handleCloseErrorPopup = () => {
    setOpenErrorPopup(false);
  };

  // successPopup
 const handleOpenSuccessPopup = () => setOpenSuccesPopup(true);
  const handleCloseSuccessPopup = () => setOpenSuccesPopup(false);

 // RezorPay Functionality

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;

      script.onload = () => {
        resolve(true);
      };

      script.onerror = () => resolve(false);

      document.body.appendChild(script);
    });
  };

  console.log("totalAmount?.total" , totalAmount?.total)
  const handleProceedToPay = async () => {
    
   if (!checked) {
      setShowMessga(
        "Kindly review and accept the Terms and Conditions to proceed further."
      );
      setButtonTitle("Okay, Got It");
      handleOpenErrorPopup();
      return;
    }
    if(defaultSelectedTestData?.length===0){
        setShowMessga(
        "Please select at least one test to proceed with payment"
      );
      setButtonTitle("Okay, Got It");
      handleOpenErrorPopup();
      return
    }

if (!defaultAddressData?.id) {
      setShowMessga("Please choose an address before continuing");
      setButtonTitle("Got It");
      handleOpenErrorPopup();
      setPaymentProcessLoading(false);
      return;
    }

    setPaymentProcessLoading(true);
    
    const orderDetailsArray = defaultSelectedTestData.map((item) => {
  const qty = Number(item.quantity || 1);
  const price = Number(item.base_price || 0);

  return {
    user_id: parseInt(userId),
    billing_address_id: defaultAddressData?.id,
    rt_product_id: item.id,
    quantity: qty,
    currency: item.currency,
    payment_mode_id: 2,
    amount_to_be_paid: price * qty,
    amount_paid: price * qty
  };
});

console.log("orderDetailsArray",orderDetailsArray)
    

    let orderData;

    // Create order

    try {
      const response = await handleFetchRealTestOrderApi(
        orderDetailsArray,
      );

      if (response.status === 201) {
        orderData = response?.data;

        const res = await loadScript(
          "https://checkout.razorpay.com/v1/checkout.js"
        );

        if (!res) {
          alert("Razorpay SDK failed to load. Are you online?");
          return;
        }

        const options = {
          key: `${RAZORPAY_KEY_ID}`,
          amount: orderData?.amount,
          currency: orderData?.currency,
          name: "Scholastic Test Masters",
          description: "Secure payment for your selected test",
         image: "https://stmstudentdev-api.siectestmasters.in/uploads/file-1759924150563.png", 
          order_id: orderData?.id,
          handler: async function (response) {
            const rezorpayResponse = response;

            // Run Verify payment api

            try {
              const response = await handleRealTestVerifyPayment(rezorpayResponse);

              if (response.status === 200) {
                setShowMessga(
                  "A Message and email will sent once the payment has been confirmed by our team. Navigate to our performance dashboard to view your test details and start your journey."
                );
                handleOpenSuccessPopup();
                setPaymentProcessLoading(false);
              } else if (response.status === 400) {
                setShowMessga(
                  "There was a technical issue while confirming your payment. Please avoid retrying. Our support team will reach out to assist you shortly."
                );
                setButtonTitle("Got It");
                handleOpenErrorPopup();
                setPaymentProcessLoading(false);
              } else {
                setShowMessga(
                  "There was a technical issue while confirming your payment. Please avoid retrying. Our support team will reach out to assist you shortly."
                );
                setButtonTitle("Got It");
                handleOpenErrorPopup();
                setPaymentProcessLoading(false);
              }
            } catch (err) {
              setShowMessga(
                "There was a technical issue while confirming your payment. Please avoid retrying. Our support team will reach out to assist you shortly."
              );
              setButtonTitle("Got It");
              handleOpenErrorPopup();
              setPaymentProcessLoading(false);
            }
          },
          prefill: {
            // name: billingData?.fullName, // Prepopulate customer name if available
            // email: { email }, // Prepopulate customer email if available
          },
          modal: {
            confirm_close: true, // this is set to true, if we want confirmation when clicked on cross button.

            ondismiss: function (reason) {
              switch (reason) {
                case undefined:
                  setShowMessga("You have cancelled the payment.");
                  setButtonTitle("Retry Payment");
                  handleOpenErrorPopup();
                  setPaymentProcessLoading(false);
                  break;
                case "timeout":
                  setShowMessga(
                    "Your payment session timed out. Please try again."
                  );
                  setButtonTitle("Retry Payment");
                  handleOpenErrorPopup();
                  setPaymentProcessLoading(false);
                  break;
                case "payment_failed":
                  setShowMessga(
                    "Your payment failed. Please try again or use a different payment method."
                  );
                  setButtonTitle("Retry Payment");
                  handleOpenErrorPopup();
                  setPaymentProcessLoading(false);
                  break;
                case "payment_cancelled":
                  setShowMessga(
                    "The payment was cancelled. Please try again."
                  );
                  setButtonTitle("Retry Payment");
                  handleOpenErrorPopup();
                  setPaymentProcessLoading(false);
                  break;
                case "payment_declined":
                  setShowMessga(
                    "Your payment was declined. Please check with your bank or try another method."
                  );
                  setButtonTitle("Retry Payment");
                  handleOpenErrorPopup();
                  setPaymentProcessLoading(false);
                  break;
                case "payment_timed_out":
                  setShowMessga("Your payment timed out. Please try again.");
                  setButtonTitle("Retry Payment");
                  handleOpenErrorPopup();
                  setPaymentProcessLoading(false);
                  break;
                case "payment_collect_request_expired":
                  setShowMessga(
                    "The payment request expired. Please initiate a new payment."
                  );
                  setButtonTitle("Retry Payment");
                  handleOpenErrorPopup();
                  setPaymentProcessLoading(false);
                  break;
                default:
                  setShowMessga(
                    "An unknown error occurred. Please try again."
                  );
                  setButtonTitle("Retry Payment");
                  handleOpenErrorPopup();
                  setPaymentProcessLoading(false);
                  break;
              }
            },
          },
          timeout: 900,
          theme: {
            color: "#572575", // Customize the theme color as per your requirement
          },
        };

        const razorpay = new window.Razorpay(options);

        razorpay.on("payment.failed", function (response) {
          console.error("Razorpay payment.failed event:", response);

          setShowMessga(
            response.error?.description ||
              "Payment failed. Please try again or use a different payment method."
          );
          setButtonTitle("Retry Payment");
          handleOpenErrorPopup();
          setPaymentProcessLoading(false);
        });

        document.body.style.overflow = "auto";

        try {
          razorpay.open();
        } catch (error) {
          console.error("Razorpay Checkout error:", error);
          setShowMessga(error.description);
          setButtonTitle("Retry Payment");
          handleOpenErrorPopup();
          setPaymentProcessLoading(false);
        }
      } else {
        setShowMessga(response?.message);
        setButtonTitle("Got It");
        handleOpenErrorPopup();
        setPaymentProcessLoading(false);

        document.body.style.overflow = "auto";
      }
    } catch (error) {
      setShowMessga("Internal Server Error");
      setButtonTitle("Got It");
      handleOpenErrorPopup();
      setPaymentProcessLoading(false);
      document.body.style.overflow = "auto";
    }
  };

  console.log('defaultSelectedTestData',defaultSelectedTestData)

  return (
    <>
      <GlobalCard height="100%">
        <Grid container spacing={2}>

 {paymentProceessLoading && (
          <Grid item xs={12}>
            <Backdrop open={paymentProceessLoading} style={{ zIndex: 9999 }}>
              <Loader text="Submitting your payment, please wait..." />
            </Backdrop>
          </Grid>
        )}

          <Grid item xs={12}>
            <Typography
              textAlign="start"
              color="#222222"
              fontFamily="Inter"
              fontSize="18px"
              lineHeight="100%"
              letterSpacing="0px"
              fontStyle="normal"
              style={{ fontWeight: 600 }}
            >
              Order Summary
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ borderColor: " #DDDDDD" }} />
          </Grid>

          <Grid item xs={12} container justifyContent="space-between">
            <Typography
              textAlign="start"
              color="#555555"
              fontFamily="Inter"
              fontSize="14px"
              lineHeight="100%"
              letterSpacing="0px"
              fontStyle="normal"
              style={{ fontWeight: 400 }}
            >
              Subtotal
            </Typography>

            <Typography
              textAlign="end"
              color="#444444"
              fontFamily="Inter"
              fontSize="14px"
              lineHeight="100%"
              letterSpacing="0px"
              fontStyle="normal"
              style={{ fontWeight: 600 }}
            >
              {currency} {totalAmount?.subTotal}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ borderColor: " #DDDDDD" }} />
          </Grid>

          <Grid item xs={12} container justifyContent="space-between">
            <Typography
              textAlign="start"
              color="#555555"
              fontFamily="Inter"
              fontSize="14px"
              lineHeight="100%"
              letterSpacing="0px"
              fontStyle="normal"
              style={{ fontWeight: 400 }}
            >
              Discount
            </Typography>

            <Typography
              textAlign="end"
              color="#444444"
              fontFamily="Inter"
              fontSize="14px"
              lineHeight="100%"
              letterSpacing="0px"
              fontStyle="normal"
              style={{ fontWeight: 600 }}
            >
              {currency} 00
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ borderColor: " #DDDDDD" }} />
          </Grid>

          <Grid item xs={12} container justifyContent="space-between">
            <Typography
              textAlign="start"
              color="#555555"
              fontFamily="Inter"
              fontSize="14px"
              lineHeight="100%"
              letterSpacing="0px"
              fontStyle="normal"
              style={{ fontWeight: 400 }}
            >
              Taxes & Pay
            </Typography>

            <Typography
              textAlign="end"
              color="#444444"
              fontFamily="Inter"
              fontSize="14px"
              lineHeight="100%"
              letterSpacing="0px"
              fontStyle="normal"
              style={{ fontWeight: 600 }}
            >
              {currency} {totalAmount?.tax}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ borderColor: " #DDDDDD" }} />
          </Grid>

          <Grid item xs={12} container justifyContent="space-between">
            <Typography
              textAlign="start"
              color="#000000"
              fontFamily="Inter"
              fontSize="16px"
              lineHeight="100%"
              letterSpacing="0px"
              fontStyle="normal"
              style={{ fontWeight: 700 }}
            >
              Total{" "}
              <span style={{ fontWeight: 400, color: "#111111" }}>
                ({defaultSelectedTestData?.length} Items) :
              </span>
            </Typography>

            <Typography
              textAlign="end"
              color="#572575"
              fontFamily="Inter"
              fontSize="18px"
              lineHeight="100%"
              letterSpacing="0px"
              fontStyle="normal"
              style={{ fontWeight: 700 }}
            >
              {currency} {totalAmount?.total}
            </Typography>
          </Grid>

          <Grid item xs={12} textAlign="center" mt={2}>
            {defaultSelectedTestData?.length===0 ?(
              <BlueDisableButton  buttonTitle={`Proceed To Pay ${currency ? currency : ""} ${
                totalAmount?.total
              }`} minWidth="100%"/>
            ) :( 
            <BlueMediumButton
              buttonTitle={`Proceed To Pay ${currency ? currency : ""} ${
                totalAmount?.total
              }`}
              minWidth="100%"
              onClick={handleProceedToPay}
            />

            )}
          </Grid>

          <Grid
            item
            xs={12}
            display="flex"
            alignItems="center"
            gap={2}
            justifyContent="center"
            mt={1}
          >
            <Checkbox
              sx={{ p: 0 }}
              checked={checked}
              onChange={handleChange}
              icon={
                <Box
                  sx={{
                    width: 20,
                    height: 20,
                    border: "1px solid #572575",
                    borderRadius: "4px",
                  }}
                />
              }
              checkedIcon={
                <Box
                  sx={{
                    width: 20,
                    height: 20,
                    border: "1px solid #572575",
                    borderRadius: "4px",
                    backgroundColor: "#572575",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    fontSize: 16,
                  }}
                >
                  <Icon icon="qlementine-icons:check-tick-12" />
                </Box>
              }
            />
            <Typography
              color="#444444"
              fontFamily="Inter"
              fontSize="12px"
              lineHeight="1.4"
              letterSpacing="0px"
              fontStyle="normal"
              style={{ fontWeight: 500 }}
            >
              By completing your purchase, you acknowledge that you have read
              and agree to our{" "}
              <a
                href="/termsAndConditions"
                underline="hover"
                style={{ color: "#00A5F5" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms of Use and Privacy Policy.
              </a>{" "}
            </Typography>
          </Grid>
        </Grid>
      </GlobalCard>

      <ErrorPopupScreen
        open={openErrorPopup}
        handleClose={handleCloseErrorPopup}
        subText={showMessage}
        buttonTitle={buttonTitle}
        maxWidth="xs"
      />

      <SussceeffulyMessageScreen
        text="Payment successful ! !"
        subText={showMessage}
        buttonTitle="Thanks, Got it"
    
         navigateLink="/test-prep/performance"
         currentLink={location.pathname}
        handleClose={handleCloseSuccessPopup}
        open={openSuccesPopup}
      />
    </>
  );
}
